import { useState } from "react"
import { useDebounce } from "react-use"

type Result<T> = [T, (value: T) => void, T]

export const useDebouncedState = <T>(initial: T, delay = 0): Result<T> => {
  const [liveValue, setLiveValue] = useState<T>(initial)
  const [debouncedState, setDebouncedState] = useState<T>(initial)
  useDebounce(
    () => {
      setDebouncedState(liveValue)
    },
    delay,
    [liveValue]
  )

  return [liveValue, setLiveValue, debouncedState]
}
